// import Modal from './components/Modal.vue'
// import Dialog from './components/Dialog.vue'
import PluginCore from './PluginCore'
const Plugin = {
  install (Vue, options = {}) {
    if (Vue.prototype.$modal) {
      return
    }

    const plugin = new PluginCore(Vue, options)

    Object.defineProperty(Vue.prototype, '$zModal', {
      get: function () {
        // 调用这个modal的示例
        const caller = this
        if (!plugin.context.root) {
          plugin.setDynamicModalContainer(caller.$root)
        }
        return plugin
      }
    })
  }
}

export default Plugin



// WEBPACK FOOTER //
// ./src/utils/plugins/zModel/index.js